import { useCallback } from 'react';
import {
  usePositionFiltersModalActions,
  usePositionFiltersModalView,
} from '@paradigm/features/src/positions/contexts/filters/modal';
import {
  FiltersState,
  usePositionFiltersActions,
} from '@paradigm/features/src/positions/contexts/filters/store';
import PositionFiltersForm from '#/components/UnifiedRfqs/positions/filters/PositionFiltersForm';
import useIsMobile from '@paradigm/design-system/src/hooks/useIsMobile';
import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';
import { useTrackAction } from '@paradigm/features/src/analytics';

export default function PositionFiltersModal() {
  const { isOpen } = usePositionFiltersModalView();
  const { close } = usePositionFiltersModalActions();
  const filters = usePositionFiltersActions();
  const isMobile = useIsMobile();
  const trackAction = useTrackAction();

  const handleSubmit = (state: FiltersState) => {
    trackAction('apply filters', { filters: state });
    filters.setValues(state);
    close();
  };

  const handleReset = () => {
    trackAction('clear filters');
    filters.reset();
    close();
  };

  const handleClose = useCallback(() => {
    trackAction('close modal');
    close();
  }, [close, trackAction]);

  return (
    <HeadedModal
      width={662}
      isOpen={isOpen}
      aria-label="position filters modal"
      titlePlacement={isMobile ? 'center' : 'left'}
      theme={isMobile ? 'primary-dark' : 'secondary-light'}
      titleCss="font-weight: normal;"
      close={handleClose}
      title="Filters"
      footerCss="justify-content: space-between;"
    >
      <PositionFiltersForm onSubmit={handleSubmit} onReset={handleReset} />
    </HeadedModal>
  );
}
